//Commenting out until asio udpates to support node 19+
// import {MicroUiLoader} from "micro-ui-loader"; 

export class TaxServiceMicroUiWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: "",
        };
    }

    componentDidMount() {
        var getAccessToken = quosal.api.oauth.getAccessToken("CWSSO");
        getAccessToken.finished = (msg) => {
            this.setState({ token: msg.accessToken })
        };
        getAccessToken.call();    
    }

    render() {
        return (
            <div id="tax-module-container">
                <div>Tax service is disabled</div>
                {/* <MicroUiLoader
                    packageKey="tax-codes"
                    divId="tax-module-container"
                    tokenData={{
                        tokenType:"cwSSO",
                        environment:app.settings.global.MicroUIServiceEnvironment ?? "production",
                        token:this.state.token
                    }}
                /> */}
            </div>
        );
    }
}
global.TaxServiceMicroUiWrapper = TaxServiceMicroUiWrapper;